function FinishScreen({points, maxPossiblePoints, highscore, dispatch}) {
    const percentage = (points/maxPossiblePoints) * 100;
    return (
        <>  <p className="highscore">Highest Score {highscore}</p>
            <p className="result">
                You scored {points} out of {maxPossiblePoints}
               
            </p>
            

            <button className="btn btn-ui" onClick={()=>dispatch({type: "restart"})}>Restart the Quiz</button>
        </>
    )
}

export default FinishScreen
